module.exports = __webpack_public_path__ + "img/vertical_4_4_1.eadde214.png";